import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17l4 4","key":"svg-0"}],["path",{"d":"M7 17l-4 4","key":"svg-1"}],["path",{"d":"M17 3l4 4","key":"svg-2"}],["path",{"d":"M21 3l-4 4","key":"svg-3"}],["path",{"d":"M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2","key":"svg-4"}]]

const IconRouteX2 = createReactComponent('outline', 'route-x-2', 'RouteX2', __iconNode);

export default IconRouteX2;